import React, { useState } from "react";
import { NavLink, useLocation, useMatch } from "react-router-dom";
import LanguageIcon from "@mui/icons-material/Language";
import {
  Box,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import Login from "../common/Login";
import ReactCountryFlag from "react-country-flag";

const MobileNav = ({ logo }) => {
  const isHomePage = useMatch("/");
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [languages] = useState([
    { country_code: "US", code: "en", language: "English" },
  ]);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const path = useLocation();

  return (
    <nav
      className="mobile-header home-header"
      style={
        isHomePage
          ? { background: "transparent" }
          : { background: "var(--primary-color--)" }
      }
    >
      <Grid
        container
        className="mobileNav"
        style={{ alignItems: "center", paddingTop: "0px" }}
      >
        <Grid item md={8} className="mobileNavGrid">
          <div className="logo">
            <NavLink to="/">
             <div className="logo-wrapper ">
                <img src={logo} alt="logo" />
              </div>
            </NavLink>
          </div>
        </Grid>
        <Grid
          item
          md={2}
          className="mobileNavGrid"
          sx={{
            display: "flex",
            alignItems: "center",
            marginLeft: "auto",
          }}
        >
          <Box>
            <Login/>
          </Box>
          <Box sx={{ marginLeft: "8px" }}>
            <Tooltip title="Language">
              <IconButton
                className="share-btn"
                onClick={handleOpenNavMenu}
                sx={{ fontSize: "18px", color: "#fff" }}
              >
                <LanguageIcon />
              </IconButton>
            </Tooltip>
          </Box>
          <Menu
            sx={{ mt: "45px" }}
            id="menu-appbar"
            anchorEl={anchorElNav}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            open={Boolean(anchorElNav)}
            onClose={handleCloseNavMenu}
          >
            {languages &&
              languages.map((lang, index) => {
                const { country_code, code, language } = lang;
                return (
                  <MenuItem
                    key={index}
                    onClick={handleCloseNavMenu}
                    value={language}
                  >
                    <Typography
                      onClick={() => console.log(`Language changed to ${code}`)}
                      className="lng-btn"
                    >
                      <span className="flag-icon">
                        <ReactCountryFlag
                          style={{
                            width: "1.5em",
                            height: "1.5em",
                            marginRight: "20px",
                          }}
                          countryCode={country_code}
                          svg
                          title={country_code}
                        />
                      </span>
                      {language}
                    </Typography>
                  </MenuItem>
                );
              })}
          </Menu>
        </Grid>
      </Grid>
    </nav>
  );
};

export default MobileNav;
